import { StateLabel } from "../ui";

export function StockBadge({ inStock, level }: { inStock: boolean; level?: number | null }) {
	if (!inStock) {
		return <StateLabel state="gone" label="Out of stock" />;
	}
	return <StateLabel state="live" label={`In stock${typeof level === "number" ? ` · ${level}` : ""}`} />;
}
